import { render, staticRenderFns } from "./ThemeMultipleFiles.vue?vue&type=template&id=a2845954"
import script from "./ThemeMultipleFiles.vue?vue&type=script&lang=js"
export * from "./ThemeMultipleFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports